import { BaseService } from '@flint/framework';

export default class EditSubscription extends BaseService {
  constructor() {
    super("EDITING_USER_DATA", 'EditUserStore', true);
  }

  handleEvent(eventName, user) {
    return this.getClient('vetService').patch('/admin-api/users/', user);
  }
}